import SiafLiteApiRepository from "../../external/siafLiteApi";

class CestService {
  constructor() {
    this.urlBase = "/fiscal/cest";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filtros) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filtros);
  }
}

export default CestService;
